import React, { useState, useEffect, useCallback } from "react";
import { useFormik } from "formik";
import classNames from "classnames";
import { handleGetRequest } from "../../services/GetTemplate";
import { useDispatch } from "react-redux";
import { handlePostRequest } from "../../services/PostTemplate";
import AsyncSelect from "react-select/async"; // ✅ Use AsyncSelect instead
import Select from "react-select";
import moment from "moment";
import { InputText } from "primereact/inputtext";
import { debounce } from "lodash"; // Add lodash to package.json
import styles from "./AddLabelDialog.module.scss";

const AddLabelDialog = ({ onHideTyreBrandDialog, onsuccess }) => {
    const [pack, setPack] = useState([]);
    const dispatch = useDispatch();
    const [selectedPackage, setSelectedPackage] = useState();
    const [fetchedPackage, setFetchedPackage] = useState();
    const [type, setType] = useState(null);
    const [FNo, setFNo] = useState(null);
    const [filteredPackages, setFilteredPackages] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState();
    const [finalPackages, setFinalPackages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            barcode: "",
            consigneeName: "",
            description: "",
            weight: "",
            flightNumber: "",
            courierName: "",
            shipmentNumber: "",
            numberOfPieces: "",
            trackingNumber: "",
            unit: "",
            shipmentMethod: "",
            deliveryAddress: "",
            date: moment().format("DD-MM-YYYY"),
            deliveryInfo: "",
        },

        onSubmit: async (data) => {
            setLoading(true);
            try {
                if (type === "flight") {
                    const dat = finalPackages?.length > 0 ? finalPackages : filteredPackages;
                    const result = await dispatch(handlePostRequest(dat, "/AddMassLabel", true, true));
                    if (result !== "error") {
                        onsuccess();
                    }
                } else if (type === "package") {
                    const user = await handleGetRequest("/getuser/" + fetchedPackage?.name?._id);
                    data.barcode = fetchedPackage?._id;
                    data.consigneeName = fetchedPackage?.consigneeName;
                    data.description = fetchedPackage?.description;
                    data.weight = fetchedPackage?.weight?.number;
                    if (fetchedPackage?.shipmentMethod === "air") {
                        data.flightNumber = fetchedPackage?.flightNumber;
                    }
                    data.courierName = fetchedPackage?.courierName?.courier?.businessName;
                    data.unit = fetchedPackage?.weight?.unit;
                    if (fetchedPackage?.shipmentMethod === "shipment") {
                        data.shipmentNumber = fetchedPackage?.shipmentNumber;
                    }
                    data.numberOfPieces = fetchedPackage?.numberOfPieces;
                    data.trackingNumber = fetchedPackage?.Waybill;
                    data.shipmentMethod = fetchedPackage?.shipmentMethod;
                    if (user?.data?.role === "client") {
                        data.deliveryAddress = user?.data?.client?.deliveryAddress;
                    } else {
                        data.deliveryAddress = user?.data?.courier?.deliveryAddress;
                    }
                    data.deliveryInfo = fetchedPackage?.deliveryInfo;
                    const result = await dispatch(handlePostRequest(data, "/addLabel", true, true));
                    if (result !== "error") {
                        onsuccess();
                    }
                }
            } finally {
                setLoading(false);
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <div className={styles.errorMessage}>{formik.errors[name]}</div>;
    };

    // ✅ FIX 1: Load async options for package search
    const loadPackageOptions = async (inputValue) => {
        try {
            // If no search input, return first 50 packages
            if (!inputValue || inputValue.length < 2) {
                const res = await handleGetRequest("/allPackages");
                const packages = res?.data || [];
                return packages.slice(0, 50).map((item) => ({
                    label: `${item?.Waybill} - ${item?.billTo || "N/A"}`,
                    value: item?._id,
                    data: item,
                }));
            }

            // Search backend for matching waybills
            const res = await handleGetRequest("/allPackages");
            const packages = res?.data || [];

            console.log("Loaded packages for search:", packages.length, packages);

            // Filter by waybill (case-insensitive)
            const filtered = packages.filter((item) => item?.Waybill?.toLowerCase().includes(inputValue.toLowerCase()));

            return filtered.slice(0, 50).map((item) => ({
                label: `${item?.Waybill} - ${item?.billTo || "N/A"}`,
                value: item?._id,
                data: item,
            }));
        } catch (error) {
            console.error("Error loading packages:", error);
            return [];
        }
    };

    // Debounce the search to avoid too many API calls
    const debouncedLoadOptions = useCallback(
        debounce((inputValue, callback) => {
            loadPackageOptions(inputValue).then(callback);
        }, 500),
        [],
    );

    // ✅ FIX 2: Refresh flight packages from backend when FNo changes
    const searchPackagesByFlight = async (flightNumber) => {
        if (!flightNumber) {
            setFilteredPackages([]);
            setUsers([]);
            setSelectedUser(null);
            setFinalPackages([]);
            return;
        }

        setSearchLoading(true);
        try {
            // ✅ Fetch fresh data from backend
            const res = await handleGetRequest("/allPackages");
            const allPackages = res?.data || [];

            const teme = [];
            const regex = new RegExp(flightNumber, "i");

            allPackages.forEach((item) => {
                if (regex.test(item?.flightNumber)) {
                    teme.push({
                        barcode: item._id,
                        consigneeName: item?.consigneeName,
                        description: item?.description,
                        weight: item?.weight?.number,
                        flightNumber: item?.flightNumber,
                        courierName: item?.courierName?.courier?.businessName,
                        unit: item?.weight?.unit,
                        shipmentNumber: item?.shipmentNumber,
                        trackingNumber: item?.Waybill,
                        shipmentMethod: item?.shipmentMethod,
                        deliveryAddress: item?.name?.client?.deliveryAddress,
                        date: moment().format("DD-MM-YYYY"),
                        deliveryInfo: item?.deliveryInfo,
                        user: item?.name?._id,
                        name: item?.name?.firstName + " " + item?.name?.lastName,
                    });
                }
            });

            // Build unique users list
            const billTo = teme?.reduce((acc, item) => {
                const exists = acc.find((user) => user.value === item.user);
                if (!exists && item.user) {
                    acc.push({
                        label: item.name,
                        value: item.user,
                    });
                }
                return acc;
            }, []);

            setUsers(billTo);
            setFilteredPackages(teme);
            setSelectedUser(null); // Reset user selection
            setFinalPackages([]); // Reset filtered packages
        } catch (error) {
            console.error("Error searching packages:", error);
        } finally {
            setSearchLoading(false);
        }
    };

    // ✅ Debounce flight number search
    const debouncedFlightSearch = useCallback(
        debounce((flightNumber) => {
            searchPackagesByFlight(flightNumber);
        }, 500),
        [],
    );

    // Trigger search when flight number changes
    useEffect(() => {
        if (FNo) {
            debouncedFlightSearch(FNo);
        } else {
            setFilteredPackages([]);
            setUsers([]);
        }
    }, [FNo, debouncedFlightSearch]);

    const handleSelectedPackage = (selectedOption) => {
        if (selectedOption?.data) {
            setFetchedPackage(selectedOption.data);
        } else {
            setFetchedPackage(null);
        }
    };

    const handleSelectedUser = (selectedOption) => {
        setSelectedUser(selectedOption);
        if (selectedOption) {
            const filteredPackage = filteredPackages.filter((item) => item?.name === selectedOption?.label);
            setFinalPackages(filteredPackage);
        } else {
            setFinalPackages([]);
        }
    };

    const packageCount = finalPackages?.length > 0 ? finalPackages?.length : filteredPackages?.length;

    return (
        <div className={styles.dialogContainer}>
            <form onSubmit={formik.handleSubmit} className={styles.formSection}>
                {/* Label Type Selection */}
                <div className={styles.fieldGroup}>
                    <label htmlFor="labelType" className={classNames(styles.label, { required: true })}>
                        Label Type
                    </label>
                    <select
                        id="labelType"
                        className={styles.select}
                        value={type || ""}
                        onChange={(e) => {
                            setType(e.target.value);
                            // Reset all selections when type changes
                            setSelectedPackage(null);
                            setFetchedPackage(null);
                            setFNo(null);
                            setFilteredPackages([]);
                            setUsers([]);
                            setSelectedUser(null);
                            setFinalPackages([]);
                        }}
                    >
                        <option value="" disabled>
                            Select Label Type
                        </option>
                        <option value="package">By Package</option>
                        <option value="flight">By Flight Number</option>
                    </select>
                </div>

                {/* Flight Number Section */}
                {type === "flight" && (
                    <>
                        <div className={styles.fieldGroup}>
                            <label htmlFor="flightNumber" className={styles.label}>
                                Flight Number
                            </label>
                            <div className={styles.inputWrapper}>
                                <InputText id="flightNumber" name="flightNumber" value={FNo || ""} onChange={(e) => setFNo(e.target.value)} placeholder="Enter flight number (min 1 character)" className="Input__Round" />
                                {searchLoading && <span style={{ marginLeft: "8px", color: "#64748b" }}>Searching...</span>}
                            </div>
                        </div>

                        {FNo && users.length > 0 && (
                            <div className={styles.fieldGroup}>
                                <label htmlFor="billTo" className={styles.label}>
                                    Bill To
                                </label>
                                <div className={styles.selectWrapper}>
                                    <Select id="billTo" options={users} value={selectedUser} onChange={handleSelectedUser} placeholder="Select recipient" isClearable />
                                </div>
                            </div>
                        )}

                        {FNo && users.length === 0 && !searchLoading && <div className={styles.errorMessage}>No packages found for flight number "{FNo}"</div>}
                    </>
                )}

                {/* Package Selection */}
                {type === "package" && (
                    <div className={styles.fieldGroup}>
                        <label htmlFor="packageNumber" className={styles.label}>
                            Package Number (Waybill)
                        </label>
                        <div className={styles.selectWrapper}>
                            <AsyncSelect
                                id="packageNumber"
                                cacheOptions
                                defaultOptions
                                loadOptions={debouncedLoadOptions}
                                onChange={(option) => {
                                    setSelectedPackage(option);
                                    handleSelectedPackage(option);
                                }}
                                value={selectedPackage}
                                placeholder="Type to search waybill..."
                                isClearable
                                noOptionsMessage={({ inputValue }) => (inputValue.length < 2 ? "Type at least 2 characters to search" : "No packages found")}
                            />
                        </div>
                        <small style={{ color: "#64748b", fontSize: "0.75rem", marginTop: "4px" }}>Start typing the waybill number to search</small>
                    </div>
                )}

                {/* Package Count Display */}
                {filteredPackages?.length > 0 && (
                    <div className={styles.countSection}>
                        <div className={styles.labelCount}>
                            <div className={styles.countIcon}>{packageCount}</div>
                            <div className={styles.countText}>
                                <span className={styles.countNumber}>{packageCount}</span> Label{packageCount !== 1 ? "s" : ""} ready to generate
                            </div>
                        </div>
                    </div>
                )}

                {/* Submit Button */}
                <div className={styles.buttonGroup}>
                    <button type="submit" className={classNames(styles.generateButton, { [styles.loading]: loading })} disabled={loading || !type || (type === "flight" && filteredPackages.length === 0) || (type === "package" && !selectedPackage)}>
                        {!loading && <span className={styles.buttonIcon}>📄</span>}
                        {loading ? "Generating..." : "Generate Label"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddLabelDialog;
